// frontend/src/components/auth/RequireAdmin.js
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function RequireDeveloper({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <p>로딩 중...</p>;
  if (!user || user.role !== 'developer') {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
}
